import React from 'react';
import { User } from 'lucide-react';
import { API_URL } from '../lib/utils';

export function UserAvatar({ user, size = 'md', className = '' }) {
  const sizes = { sm: 'w-6 h-6', md: 'w-8 h-8', lg: 'w-10 h-10', xl: 'w-16 h-16' };
  const iconSizes = { sm: 'w-3 h-3', md: 'w-4 h-4', lg: 'w-5 h-5', xl: 'w-8 h-8' };
  const sizeClass = sizes[size] || sizes.md;
  const iconSize = iconSizes[size] || iconSizes.md;

  const avatarUrl = user?.avatar_url
    ? (user.avatar_url.startsWith('http') ? user.avatar_url : `${API_URL.replace('/api', '')}${user.avatar_url}`)
    : null;

  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={user?.first_name || 'Avatar'}
        className={`${sizeClass} rounded-full object-cover border-2 border-white shadow-sm ${className}`}
        data-testid="user-avatar-img"
      />
    );
  }

  return (
    <div className={`${sizeClass} rounded-full bg-[#7FD02E]/20 flex items-center justify-center ${className}`} data-testid="user-avatar-placeholder">
      <User className={`${iconSize} text-[#7FD02E]`} />
    </div>
  );
}
